<template>
  <div class="orderDetail">
    <div class="hed">
      <span class="number">订单号码：{{payOrder.orderNo}}</span>
      <span class="status"> {{ $properties(payOrder.payStatus,'label') }}</span>
    </div>
    <div class="ordercon">
      <div class="title1">
        <div class="status2">
          <div class="con1">
            <span>等待付款</span>
            <p>剩13分50秒自动关闭</p>
            <p class="text">因为您长时间没有支付费用，<br />订单已经失效</p>
          </div>
        </div>
        <div class="condiv" style="margin-top: 10px;">
          <p class="title">请选择优惠券</p>
        </div>
        <div style="background-color: white; padding: 1rem; margin-top: 1rem;">
          <div style="font-size: 1.5rem; padding-top: 1rem; height: 3rem;">
            提货点
          </div>
          <div style="font-size: 1.3rem; padding-top: 1rem; height: 3rem;">
            嘉盛陵园
          </div>
        </div>
      </div>
      <div class="content">
        <!-- 商城订单 -->
        <template v-if="type == 'shop'">
          <section v-for="(item2, index2) in payOrder['goodsList']" :key="index2">
            <div class="img">
              <img src="../../../assets/shop.jpg" />
            </div>
            <div class="text">
              <p class="title">祭思套餐</p>
              <p class="ms">规格: 祭思套餐</p>
              <div class="amount">
                <span class="price">￥159</span>
                <span class="no">× &nbsp;1</span>
              </div>
            </div>
          </section>
            <!-- <img :src="item2.firstPhoto" class="pic2" />
            <div class="info">
              <span class="name">{{ item2.proName }}</span> <br />
              <span class="size">规格: {{ item2.specification.name }}</span> <br />
              <span class="money">￥{{ item2.price }}</span>
              <span class="num">× {{ item2.count }}</span>
            </div>
            <img src="../../../assets/li.svg" class="line" /> -->
          <!-- </div> -->
        </template>
        <!-- 盆花租摆 -->
        <template v-if="type == 'rented'">
          <div class="shop" v-for="(item2, index2) in payOrder['goodsList']" :key="index2">
            <img :src="item2.firstPhoto" class="pic2" />
            <div class="info">
              <span class="name">{{ item2.proName }}</span> <br />
              <span class="size">规格: {{ item2.specification.name }}</span> <br />
              <span class="money">￥{{ item2.price }}</span>
              <span class="num">× {{ item2.count }}</span>
            </div>
            <img src="../../../assets/li.svg" class="line" />
          </div>
        </template>
        <!-- 代客祭扫 -->
        <template v-if="type == 'replace'">
          <div class="shop" v-for="(item2, index2) in payOrder['goodsList']" :key="index2">
            <img :src="item2.firstPhoto" class="pic2" />
            <div class="info">
              <span class="name">{{ item2.proName }}</span> <br />
              <span class="size">规格: {{ item2.specification.name }}</span> <br />
              <span class="money">￥{{ item2.price }}</span>
              <span class="num">× {{ item2.count }}</span>
            </div>
            <img src="../../../assets/li.svg" class="line" />
          </div>
        </template>
        <!-- 预订服务  -->
        <template v-if="type == 'subscribe'">
          <div class="shop" v-for="(item2, index2) in payOrder['goodsList']" :key="index2">
            <img :src="item2.firstPhoto" class="pic2" />
            <div class="info">
              <span class="name">{{ item2.proName }}</span> <br />
              <span class="size">规格: {{ item2.specification.name }}</span> <br />
              <span class="money">￥{{ item2.price }}</span>
              <span class="num">× {{ item2.count }}</span>
            </div>
            <img src="../../../assets/li.svg" class="line" />
          </div>
        </template>
        <!-- 维护费订单 -->
        <template v-if="type == 'maintain'">
          <div v-for="(item2, index2) in payOrder['maintainList']" :key="index2">
            <!-- 维护费的这个图片，采用固定图片，后台可以修改 -->
            <div class="maintain">
              <span class="name">缴纳维护费</span> <br />
              <!-- name 固定 size 只更改年限-->
              <span class="size">规格: {{ item2.duration }}年维护费</span> <br />
              <span class="money">￥{{ item2.price }}</span>
            </div>

            <img src="../../../assets/li.svg" class="line" />
          </div>
        </template>
        <!-- <section>
          <div class="img">
            <img src="../../../assets/shop.jpg" />
          </div>
          <div class="text">
            <p class="title">祭思套餐</p>
            <p class="ms">规格: 祭思套餐</p>
            <div class="amount">
              <span class="price">￥159</span>
              <span class="no">× &nbsp;1</span>
            </div>
          </div>
        </section> -->
      </div>
      <div class="ma">
        <span class="ordertime">下单时间&nbsp;&nbsp; <span>{{ payOrder.orderDate }}</span></span>
        <p class="ordertime">订单备注&nbsp;&nbsp; <span></span></p>
      </div>
      <div class="ma">
        <p class="ordertime">管理员反馈&nbsp;&nbsp; <span></span></p>
      </div>
    </div>
    <div class="bottom">
      <ul>
        <li v-if="payOrder.payStatus.value == '2'">
          <div class="pay" @click="goPay(payOrder.orderNo)">去支付</div>
        </li>
        <li><div class="pay" @click="goOrder()">我的订单</div></li>
        <!-- <li>
          <div class="delete" style="display: none;">下载发票</div>
        </li>

        <li>
          <div class="pay" style="display: none;">评价</div>
        </li> -->
        <li>
          <div class="delete" @click="deleteOrder(payOrder.orderNo)">删除订单</div>
        </li>
        <li  v-if="payOrder.payStatus.value == '2'">
          <div class="delete" @click="cancelOrder(payOrder.orderNo)">取消订单</div>
        </li>
      </ul>
    </div>

    <!-- <div class="clear-both"></div>
    <section class="foot">
      <p class="price">需要支付：<i>¥ 159</i></p>
      <a class="goto">支付</a>
    </section> -->

    <!-- <div class="">
      <div class="success">
        <p class="title">支付成功</p>
        <span class="text">您已成功支付<br />可在我的订单查看订单详情</span>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'cart',
  data() {
    return {
      type: '',
      pageName: '',
      payOrder: {
        orderNo: '',
        customMemo: '',
        orderDate: '',
        specification: {},
        amount: 0,
        maintainAddress: '',
        orderType: {},
        payStatus: {},
        goodsList: [],
        maintainList: [],
      },
    }
  },
  created() {
    this.pageName = this.$route.params.id
    this.type = this.$route.params.type
    this.queryOrderOne(this.pageName)
  },
  mounted() {
    this.pageName = this.$route.params.id
  },
  methods: {
    goPay(orderNo) {
      this.$router.push({ path: '/shop/payok', query: { orderNo: orderNo } })
    },
    goOrder() {
      var type = this.$route.params.type
      this.$router.push({ path: '/shop/orders/' + type })
    },
    queryOrderOne(orderNo){
      var that = this
      this.$queryOne(
        '/api/order/queryOrderByNo',
        {'orderNo':orderNo, myId:this.$store.getters.userId},
        function(res) {
          that.$fill(that.payOrder, res['data'])
        }
      )
    },
    cancelOrder(orderNo){
      var that = this
      if(window.confirm('你确定要取消订单吗？')){
        that.$submit('/api/order/cancelOrder', {orderNo:orderNo}, function(res) {
          if (res['code'] === 1) {
            that.queryOrderOne(orderNo)
          }
        })
      }
    },
    deleteOrder(orderNo){
      var that = this
      if(window.confirm('你确定要删除订单吗？')){
        that.$submit('/api/order/deleteOrder', {orderNo:orderNo}, function(res) {
          if (res['code'] === 1) {
            var type = that.$route.params.type
            that.$router.push({ path: '/shop/orders/' + type })
          }
        })
      }
    },
    goto(str) {
      this.$router.push({ path: str })
    },
  },
}
</script>

<style>
.orderDetail .bottom {
  height: 4.9rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 5rem;
  z-index: 999;
  border: 0.1rem solid #eee;
}
.orderDetail .bottom ul li {
  margin-top: 1rem;
}
.orderDetail .bottom ul li .pay {
  background-color: #15a892;
  color: #fff;
  float: right;
}

.orderDetail .bottom ul li div {
  width: 8rem;
  height: 3rem;
  border: 0.1rem solid #eee;
  font-size: 1.3rem;
  list-style: none;
  float: left;
  margin-right: 1rem;
  padding-top: 0.6rem;
  text-align: center;
}
.orderDetail .bottom ul li .pay {
  background-color: #15a892;
  color: #fff;
  float: right;
}
.orderDetail .bottom ul li .delete {
  color: #999;
  float: right;
}
.orderDetail .hed span {
  font-size: 1.4rem;
}
.orderDetail .hed .status {
  float: right;
  position: relative;
  right: 1.5rem;
  color: #15a892;
}
.orderDetail .hed {
  width: 100%;
  height: 4.6rem;
  background-color: #fff;
  font-size: 1.4rem;
  padding-left: 2rem;
  letter-spacing: 0.1rem;
  padding-top: 1.3rem;
}
.orderDetail .ordercon {
  margin-top: -2rem;
  padding: 0 1rem;
  background: #f3f3f3;
  height: 10rem;
}

.orderDetail .ordercon .title1 {
  width: 100%;
  font-size: 1.3rem;
}
.orderDetail .status2 {
  width: 100%;
  margin-top: 3rem;
  padding: 0 1rem;
  letter-spacing: 0.1rem;
}
.orderDetail .status2 .con1 {
  width: 100%;
  text-align: center;
  padding: 1.9rem 2rem;
  font-size: 1.6rem;
  line-height: 2.5rem;
  background-color: #15a892;
}
.orderDetail .status2 .con1 .cha,
.orderDetail .status2 .con1 .svg11 {
  width: 1.5rem;
  height: 1.5rem;
  position: relative;
  top: 0.2rem;
}
.orderDetail .status2 .con1 p,
.orderDetail .status2 .con1 span {
  color: #fff;
}
.orderDetail .status2 .con1 p,
.orderDetail .status2 .con1 span {
  color: #fff;
}
.orderDetail .status2 p {
  font-size: 1.4rem;
  margin-top: 0.5rem;
}
.orderDetail .condiv {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.orderDetail .condiv .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}

.orderDetail .ordercon .content {
  margin-top: 1rem;
  background-color: #fff;
}
.orderDetail .ordercon .content section {
  height: 10rem;
  padding: 1rem;
  box-sizing: border-box;
  font-size: 1.4rem;
  display: flex;
  border-bottom: 1px solid #eee;
}
.orderDetail .ordercon .content section .img img {
  width: 8rem;
  height: 8rem;
  margin-right: 1.3rem;
}
.orderDetail .ordercon .content section .text {
  width: 100%;
}
.orderDetail .ordercon .content section .text .title {
  height: 3.7rem;
  line-height: 2rem;
  overflow: hidden;
}
.orderDetail .ordercon .content section .text .ms {
  height: 1.7rem;
  font-size: 1.2rem;
  color: #999;
}
.orderDetail .ordercon .content section .text .amount {
  display: flex;
  justify-content: space-between;
  line-height: 2.2rem;
}
.orderDetail .ordercon .content section .text .amount .price {
  font-size: 1.6rem;
  color: #15a892;
  padding-top: 0.4rem;
  font-weight: bolder;
}
.orderDetail .ma {
  height: 6rem;
  font-size: 1.4rem;
}
.orderDetail .order-remark,
.orderDetail .ma {
  background: #fff;
  left: 0;
  right: 0;
  padding: 0.5rem 1rem;
  margin-top: 1rem;
  margin-bottom: 6rem;
  width: 100%;
}
.orderDetail .ma .ordertime {
  color: #999;
}
.orderDetail .ma .ordertime {
  color: #999;
}

.orderDetail .ma p {
  margin-top: 1rem;
}
.orderDetail .clear-both {
  clear: both;
  height: 5rem;
}
.orderDetail .foot {
  background: #fff;
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 1.4rem;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  display: flex;
  justify-content: flex-end;
}
.orderDetail .foot .price {
  margin: 0 1.7rem 0 0;
}
.orderDetail .foot .price i {
  color: #15a892;
  font-weight: bolder;
}
.orderDetail .foot .goto {
  background: #15a892;
  color: #fff;
  width: 13.5rem;
  text-align: center;
}
.orderDetail .success {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  visibility: hidden;
  opacity: 0;
  transition: all 1s ease;
  border: 1px solid #eee;
  width: 22rem;
  padding: 3rem 1rem;
  font-size: 1.4rem;
  border-radius: 0.5rem;
  text-align: center;
  background: #fff;
  box-shadow: 1px 2px 5px rgb(0 0 0 / 20%);
}
.orderDetail .success .title {
  color: #15a892;
}
.orderDetail .success .title:before {
  width: 5.5rem;
  height: 5.5rem;
  margin: 0 auto 1rem;
  display: block;
  content: '';
  /* background: url() no-repeat 50%; */
  background-size: contain;
}
.orderDetail .success .text {
  color: #999;
  line-height: 2.4rem;
  margin-top: 2.4rem;
  display: block;
}
</style>
